import { render, staticRenderFns } from "./StartStopTimer.vue?vue&type=template&id=0764db93&scoped=true&"
import script from "./StartStopTimer.vue?vue&type=script&lang=ts&"
export * from "./StartStopTimer.vue?vue&type=script&lang=ts&"
import style0 from "./StartStopTimer.vue?vue&type=style&index=0&id=0764db93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764db93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
